import { render, staticRenderFns } from "./PerformanceStats.vue?vue&type=template&id=3f3fdc74&scoped=true&"
import script from "./PerformanceStats.vue?vue&type=script&lang=js&"
export * from "./PerformanceStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3fdc74",
  null
  
)

export default component.exports